import React, { Fragment, useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import { Grid, Button, DialogActions } from '@material-ui/core';
import Auth0Button from './../Auth0Button';
import Loading from '../../../../flowtrace-components/Loading';
import MuiAlert from '@material-ui/lab/Alert';
import { useAuth0 } from "@auth0/auth0-react";
import {HelpOutline, CheckCircle, RadioButtonUnchecked} from '@material-ui/icons';
import { green, red, blue } from '@material-ui/core/colors';
import ApiFilter  from "./apiFilter"

const config = require("./../../../../config.json");

const googleMarketplaceLogo = "data:image/svg+xml;base64,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";
const googleAdminLogo = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDE5MiAxOTIiIGhlaWdodD0iMTkyIiB2aWV3Qm94PSIwIDAgMTkyIDE5MiIgd2lkdGg9IjE5MiI+PHJlY3QgZmlsbD0ibm9uZSIgaGVpZ2h0PSIxOTIiIHdpZHRoPSIxOTIiLz48Zz48Zz48cGF0aCBkPSJNMjQuNTMsMTMwbDIwLjY5LDM1Ljg0YzMuMjcsNS42Nyw5LjMyLDkuMTYsMTUuODYsOS4xNmg0NC4wNmwtNy45My0yNC4wN0w3OC4xNSwxMzBsLTI2LjgxLTQuNjYgTDI0LjUzLDEzMHoiIGZpbGw9IiMxOTY3RDIiLz48cGF0aCBkPSJNMTgyLjA2LDg2Ljg0bC0yMC4wOS0zNC44bC0xNy4yOCwxOS4xM0wxMzQuNDksOTZsMTEuMDgsMjYuNTdsMTYuMjcsMTcuNmwyMC4yMi0zNS4wMSBDMTg1LjMzLDk5LjQ5LDE4NS4zMyw5Mi41MSwxODIuMDYsODYuODR6IiBmaWxsPSIjMTk2N0QyIi8+PHBhdGggZD0iTTEwNS4xNSwxN0g2MS4wOWMtNi41NCwwLTEyLjU5LDMuNDktMTUuODYsOS4xNkwyNC41Myw2MmwyNi44MSw0LjY2TDc4LjE1LDYybDE5LjU3LTIwLjkzTDEwNS4xNSwxN3oiIGZpbGw9IiMxOTY3RDIiLz48cGF0aCBkPSJNNTcuNzUsOTZsMjAuNC0zNEgyNC41M0wxMC4xOSw4Ni44NGMtMy4yNyw1LjY3LTMuMjcsMTIuNjUsMCwxOC4zMkwyNC41MywxMzBoNTMuNjJMNTcuNzUsOTZ6IiBmaWxsPSIjNDI4NUY0Ii8+PHBhdGggZD0iTTExNC4wOSw2MmwyMC40LDM0bDI3LjQ3LTQzLjk2bC0xNC45NC0yNS44OGMtMy4yNy01LjY3LTkuMzItOS4xNi0xNS44Ni05LjE2aC0yNi4wMWwtMjcsNDVIMTE0LjA5eiIgZmlsbD0iIzQyODVGNCIvPjxwYXRoIGQ9Ik0xMTQuMDksMTMwSDc4LjE1bDI3LDQ1aDI2LjAxYzYuNTQsMCwxMi41OS0zLjQ5LDE1Ljg2LTkuMTZsMTQuODItMjUuNjdMMTM0LjQ5LDk2TDExNC4wOSwxMzB6IiBmaWxsPSIjNDI4NUY0Ii8+PC9nPjwvZz48L3N2Zz4=";
const createAlert = (type, message, paragraph) => {
  return (
    <MuiAlert key="alertMessage" severity={type} className="pt-1 mt-5 mb-5 pb-1">
      <p>{message}</p>
      {paragraph?<p>{paragraph}</p>:null}
    </MuiAlert>
  );
};

const createCurrent = (info) => {

  const current =
    <MuiAlert key="alertMessageCurrent" severity={"info"} className="pt-1 mt-5 mb-5 pb-1">
      <Grid container spacing={0} alignItems="center">
        <Grid item md={1} >
        </Grid>
        <Grid item md={11} >
          <b>Google Workspace Installation:</b>
        </Grid>
        <Grid item md={1} >
        </Grid>
        <Grid item sm={6} >
          Customer Id:
        </Grid>
        <Grid item md={5} >
          {info.customerId}
        </Grid>
        <Grid item md={1} >
        </Grid>
        <Grid item sm={6} >
          Admin:
        </Grid>
        <Grid item md={5} >
          {info.email && info.superAdmin? info.email : null}
        </Grid>
      </Grid>
    </MuiAlert>;
  const success = info.integrated?createAlert("success", "Integration between Flowtrace and Google Workspace has been established succesfully!","We have added the integration to our background processing queue and you will start to get first insights in the coming hours, and first complete insights within 24 hours."):null;
  return [success, current];
};



export default function GoogleConfigureModal(props) {
  const [install, setInstall] = useState(false);
  const [relogin, setRelogin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [current, setCurrent] = useState(null);

  const [validateTimeout, setValidateTimeout] = useState(5);
  const [validateCount, setValidateCount] = useState(0);
  const [scopes, setScopes] = useState([]);
  const [message, setMessage] = useState(null);
  const { user } = useAuth0();

  // Create a counter calculation 1 second at a time
  if(validateCount > 0)
    setTimeout(() => setValidateCount(validateCount - 1), 1000);

  const handleValidateResults = (results) => {
    // Install ok with scopes
    if(results.install && results.scopes){
      setCurrent(createCurrent(results));
      setScopes(results.scopes);
    }
    // We need relogin (i.e. access token expired)
    else if(results.requireRelogin)
      setMessage(createAlert("warning", "We need to verify that you are a 'Admin' for your Google Workspace. Please do so with your corporate Google Workspace account below."));
    // This is a soft error (i.e. back end telling us its an error)
    else if(results.message && results.install === false)
      setMessage(createAlert("info", "We could not find existing installation. You can install Flowtrace from the Google Workspace Marketplace.", "*It usually takes mere minutes to establish the connection. According to Google, it may take up to 24 hours for app to be installed for your entire Google Workspace domain, organizational unit, or groups if you have a big Workspace."));
    else
      setMessage(createAlert("error","We were unable to find existing installation. If this is unexpected, please contact our support or try again later."));

    setRelogin(results.requireRelogin?true:false);
    setInstall(results.install);
    setLoading(false);
  };
  const getCurrentScopes = async (sub) => {
    try{
      const account = props.flowtraceUser.account?props.flowtraceUser.account.account_id:"onboarding";
      const path = `/googleWorkspace/validate/${sub}/${account}`;
      const initAPI = { headers: {}, response: true };
      const response = (await API.get('slackintegration', path, initAPI)).data;

      if(response.success){
        // Check if this is a fresh install
        if(response.integrated){
          // Trigger background worked to start crunching the calendar data (wrap around try as this is not a failure case for integration):
          try{ await API.get('slackintegration', `/oauth2/install/google-workspace`); } catch(e) {console.log(e)}
          props.flowtraceUser.reload();

        }
        // Trigger a callback to onboarding (with fresh install, or just when it's a success)
        if(props.onboarding && props.onInstall){
          props.onInstall(true);
          setMessage(null);
        }
        return {install:true, ...response};
      }
      return {install:false, ...response};
    } catch(e){
      return {install:false, message:"We couldn't retrieve your current configration. Please try a re-install to ensure your integration is working."};
    }
  };



  useEffect(() => {
    let mounted = true;

    if(!user && !user.sub && !user.sub.startsWith("google-oauth2|"))
      return {install:false, requireRelogin:true, message: "You need to be logged in with Google SSO to validate and test the Google Workspace installation. Please logout, and sign in with your corporate Google account and try again."};

    // Only test scopes if the dialog is open
    if(props.open)
      getCurrentScopes(user.sub).then(res => {
        if(mounted)
          handleValidateResults(res);
      });
    return () => mounted = false;
  }, []); // eslint-disable-line react-hooks/exhaustive-deps



  const installkey = "install-button-google-workspace";
  const adminkey = "button-google-workspace-admin";
  const retrykey = "button-retry-after-install";
  const installicon = loading? <Loading tiny={true}/> : <img style={{height:"25px", width:"25px"}} alt="Logo" src={googleMarketplaceLogo} />;
  const adminicon = loading? <Loading tiny={true}/> : <img style={{height:"25px", width:"25px"}} alt="Logo" src={googleAdminLogo} />;
  const retryicon = loading? <Loading tiny={true}/> : null;
  const marketplacetext = "Install from the Google Workspace Marketplace";
  const admintext = "View setting and data access, and manage from Google Workspace Admin";
  const retrytext = "Validate the installation" + (validateCount?` (retry in ${validateCount} seconds)`:"");


  const installApp = () => { window.open("http://workspace.google.com/marketplace/app/appname/" + config.GOOGLE_WORKSPACE_APP_ID); };
  const uninstallApp = () => window.open("https://admin.google.com/u/1/ac/apps/gmail/marketplace/appdetails/" + config.GOOGLE_WORKSPACE_APP_ID);
  const retry = () => {
    setLoading(true);
    setValidateCount(validateTimeout);
    authSuccess(user);

    // Incrementally make it longer delay when the validation can be triggered
    if(validateTimeout < 60)
      setValidateTimeout(validateTimeout + 10);
  };

  const installButton = <Button key={installkey} startIcon={installicon} disabled={loading} onClick={installApp} color="primary" variant="outlined">{marketplacetext}</Button>;
  const adminButton = <Button key={adminkey} startIcon={adminicon} disabled={loading} onClick={uninstallApp} color="primary" variant="outlined">{admintext}</Button>;
  const retryButton = <Button key={retrykey} startIcon={retryicon} disabled={loading || validateCount > 0} onClick={retry} color="primary" variant="contained">{retrytext}</Button>;

  const authError = (error) => {
    console.log("authError", error);
    setMessage(createAlert("error", "We couldn't complete the verification."));
  };

  const authSuccess = (profile) => {
    setLoading(true);
    getCurrentScopes(profile.sub).then(res => {
      setMessage(""); // Reset the current message (likely saying we need verification...)
      handleValidateResults(res);
    }).finally(() => {
      setLoading(false);
    });
  };

  const installIntegration = <Button style={{width:"200px"}} key={"install-gsuite"} onClick={() => props.openDialog()} disabled={props.disabled?true:false} color="primary" variant="outlined">Install Meeting Analytics</Button>;

  if(!props.existing && !props.open)
    return installIntegration;

  const reloginButton = <Auth0Button loading={loading} connection={"google-oauth2"} cbProfile={authSuccess} cbError={authError} buttonText={"Verify your identity with Google Workspace"}/>;

  const buttons = [];
  if(!loading && relogin) buttons.push(reloginButton);
  if(!loading && !relogin && !install) buttons.push(installButton);
  if(!loading && !relogin && !install) buttons.push(retryButton);
  if(!loading && !relogin && !install && !props.onboarding) buttons.push(adminButton);
  if(!props.onboarding) buttons.push(props.cancelButton);
  const dialogButtons =
    <DialogActions style={{ justifyContent: "flex-start" }} className="mx-auto pt-5 pb-3">
      {buttons}
    </DialogActions>;

  if (loading && validateCount>0)
    return <Fragment> <Loading text="Validating the integration."/> {dialogButtons} </Fragment>;
  if (loading)
    return <Fragment> <Loading minimize={true}/> {dialogButtons} </Fragment>;



  const statusText = relogin ? "" : (install?" Read Only" : " Not found");
  const getStatus = (key) => {
    const installed = <CheckCircle key={key} style={{ color: green[500] }}/>;
    const reloginneeded = <HelpOutline key={key} style={{ color: blue[500] }}/>;
    const unknown = <RadioButtonUnchecked key={key} style={{ color: red[500] }}/>;

    const found = scopes?scopes.find(s => s.includes(key)):false;
    if(relogin) return [reloginneeded, statusText];
    if(install && found) return [installed, statusText];
    return [unknown, statusText];
  };

  const apiSettings = <ApiFilter flowtraceUser={props.flowtraceUser} type="google" />

  return (
     <Fragment>
      {!props.onboarding?apiSettings:null}
      {!props.onboarding?current:null}

      {!relogin ?
        <Grid className="mt-3" container spacing={0}>
          <Grid item md={12} >
            {!props.onboarding?"This integration requires following APIs and permissions:":null}
          </Grid>
          <Grid className="pt-3" item md={12} >
            <Grid container spacing={0} alignItems="center">
              <Grid item sm={4} >
                <b>Name of Google API</b>
              </Grid>
              <Grid item md={6} >
                <b>Purpose and usage</b>
              </Grid>
              <Grid item md={2} >
                <b>Status</b>
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12} >
            <Grid container spacing={0} alignItems="center">
              <Grid item sm={4} >
                Google Workspace Marketplace API
              </Grid>
              <Grid item md={6} >
                Licence information about Flowtrace installation
              </Grid>
              <Grid item md={2} >
                {getStatus("license")}
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12} >
            <Grid container spacing={0} alignItems="center">
              <Grid item sm={4} >
                Calendar API
              </Grid>
              <Grid item md={6} >
                Company calendars and events from Google Calendar™
              </Grid>
              <Grid item md={2} >
                {getStatus("calendar.events")}
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12} >
            <Grid container spacing={0} alignItems="center">
              <Grid item sm={4} >
                Admin SDK API: User Directory
              </Grid>
              <Grid item md={6} >
                Users and organization structure
              </Grid>
              <Grid item md={2} >
                {getStatus("directory.user")}
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12} >
            <Grid container spacing={0} alignItems="center">
              <Grid item sm={4} >
                Admin SDK API: Group Directory
              </Grid>
              <Grid item md={6} >
                Groups and group members for calendar invites
              </Grid>
              <Grid item md={2} >
                {getStatus("directory.group")}
              </Grid>
            </Grid>
          </Grid>
          <Grid item md={12} >
            <Grid container spacing={0} alignItems="center">
              <Grid item sm={4} >
                Admin SDK API: Audit reports
              </Grid>
              <Grid item md={6} >
                Video call start, and end information from Google Meets™
              </Grid>
              <Grid item md={2} >
                {getStatus("audit")}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        : null}
      {message}
      {dialogButtons}
    </Fragment>
  )
}